import DialogProvider from "@components/dialog_provider"
import { oneTimesUpdate } from "@domain/coupons"
import useTranslate from "@hooks/use_translate"
import { Stack } from "@mui/material"
import { showErrorToast, showSuccessToast } from "@utils/toast"
import { OneTimesType } from "__generated__/graphql"
import { useState } from "react"

type AddFeatureDialogProps = {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

export default function DeleteAllRedisData({
  isOpen,
  setIsOpen
}: AddFeatureDialogProps) {
  const { translate } = useTranslate()
  const [loading, setLoading] = useState(false)

  const setClose = () => {
    setIsOpen(false)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  async function onSubmit() {
    setLoading(true)
    const {
      isSuccess,
      errorMessage,
      data: responseData
    } = await oneTimesUpdate({
      type: OneTimesType.DeleteAllRedisData,
      metaData: {}
    })
    if (!isSuccess || !responseData) {
      setLoading(false)
      showErrorToast(String(errorMessage))
      return
    }

    showSuccessToast(translate("succesfully_added"))
    setLoading(false)
    handleClose()
  }
  return (
    <DialogProvider
      title={translate("delete_all_redis_data")}
      leftButton={{
        text: translate("cancel"),
        color: "secondary",
        onClick: setClose,
        disabled: loading
      }}
      rightButton={{
        text: translate("submit"),
        color: "primary",
        onClick: onSubmit,
        loading: loading,
        disabled: loading
      }}
      isOpen={isOpen}
      setClose={handleClose}
      size="small"
    >
      <Stack gap={1}>
        <p>{translate("delete_all_redis_data_message")}</p>
      </Stack>
    </DialogProvider>
  )
}
